import React, { useEffect } from 'react';
import { Button, ButtonToolbar } from 'reactstrap';
import { reduxForm, Field } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import RenderCheckBoxField from '../../../shared/components/form/CheckBox';
import RenderField from '../../../shared/components/form/RenderField';
import SmartHtmlEditor from '../../../shared/components/form/SmartHtmlEditor';
import TextAreaField from '../../../shared/components/form/TextAreaField';
import validate from './Validate';

const MemoTemplateForm = (props) => {
  const { t, initialize, change, backHandler, handleSubmit, dto } = props;

  const onContentChangeDefaultBody = (value, textValue) => {
    change('defaultBodyInHTML', value);
    change('defaultBody', textValue);
  };

  useEffect(() => {
    initialize(dto);
  }, [dto]);

  return (
    <form className="form" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label">{t('general.name')}</span>
        <div className="form__form-group-field">
          <Field
            name="name"
            type="text"
            component={RenderField}
            maxLength="50"
            placeholder={t('placeholder.memo-template.name')}
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('general.description')}
        </span>
        <div className="form__form-group-field">
          <Field
            name="description"
            type="text"
            component={TextAreaField}
            maxLength="250"
            placeholder={t('placeholder.memo-template.description')}
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('memo-template.default-title')}
        </span>
        <div className="form__form-group-field">
          <Field
            name="defaultTitle"
            type="text"
            component={RenderField}
            maxLength="100"
            placeholder={t('placeholder.memo-template.default-title')}
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('memo-template.default-body')}
        </span>
        <div className="form__form-group-field">
          <Field
            name="defaultBodyInHTML"
            component={SmartHtmlEditor}
            onEditorChange={onContentChangeDefaultBody}
            htmlValue={dto.defaultBodyInHTML}
          />
        </div>
      </div>
      <div className="form__form-group">
        <div className="form__form-group-field">
          <span className="generic__label"> {t('general.active')} </span>
          <Field
            name="active"
            component={RenderCheckBoxField}
            className="colored-click"
          />
        </div>
      </div>
      <ButtonToolbar className="form__button-toolbar">
        <Button color="primary" onClick={backHandler}>
          {t('general.back')}
        </Button>
        <Button color="success" type="submit">
          {t('general.save')}
        </Button>
      </ButtonToolbar>
    </form>
  );
};

MemoTemplateForm.propTypes = {
  t: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  dto: PropTypes.objectOf(PropTypes.shape).isRequired,
};

export default reduxForm({
  form: 'MemoTemplateForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(MemoTemplateForm));
